import React, { useEffect, useRef, useState } from 'react';
import { isEditorActive, Placeholder, Image } from '@sitecore-jss/sitecore-jss-react';
import { ContentSectionProps } from './interface';
import { useDomInView } from './hooks';

const ContentSectionComponent: React.FC<ContentSectionProps> = ({ fields, rendering }) => {
    const sectionRef = useRef<HTMLDivElement | null>(null);
    const shouldTrackInView = (fields?.extraClass?.fields?.className?.value) ? (/\b(track)\b/.test(fields.extraClass.fields.className.value)) : false;
    useDomInView(sectionRef, 'inview', 'was-inview', shouldTrackInView);

    if (!fields) {
        if (isEditorActive()) {
        return <h1 className="alarm">Datasource isn't set.</h1>;
        }
        return (
        <h1 className="alarm">
            Data is not provided. Contact administrators, please.
        </h1>
        );
    }

    var editorClasses = "imc-section--inner-content";
    if(isEditorActive()){
        editorClasses = "imc-section--inner-content imc-section--inner-content-ee"
    }
    let backgroundImage = null;
    if (fields.backgroundImage.value) {
        backgroundImage = fields.backgroundImage.value
    }

    let backgroundVideo = "";
    if (fields.videoFile && fields.videoFile.value && fields.videoFile.value.src) {
        backgroundVideo =  fields.videoFile.value.src;
    }

    let backgroundColor = fields.backgroundColor
        ? fields.backgroundColor.value
        : "default";
    let horizontalContentPosition = fields.internalContentHorizontalPosition
        ? fields.internalContentHorizontalPosition.value
        : "";
    let verticalContentPosition = fields.internalContentVerticalPosition
        ? fields.internalContentVerticalPosition.value
        : "";
    let contentBackgroundColor = fields.internalContentBackgroundColor
        ? fields.internalContentBackgroundColor.value
        : "";
    // Padding
    let paddingTop =  !!fields.paddingTop && fields.paddingTop.value!==""
        ? "imc-section--padded-top-" + fields.paddingTop.value
        : "imc-section--padded-top-xlarge";
    let paddingBottom = !!fields.paddingBottom && fields.paddingBottom.value!==""
        ? "imc-section--padded-bottom-" + fields.paddingBottom.value
        : "imc-section--padded-bottom-xlarge";
    let paddingLeft = !!fields.paddingLeft && fields.paddingLeft.value!==""
        ? "imc-section--padded-left-" + fields.paddingLeft.value
        : "imc-section--padded-left-xlarge";
    let paddingRight = !!fields.paddingRight && fields.paddingRight.value!==""
        ? "imc-section--padded-right-" + fields.paddingRight.value
        : "imc-section--padded-right-xlarge";
    
    // Padding Desktop
    let paddingTopDesktop = !!fields.paddingTopDesktop && fields.paddingTopDesktop.value!==""
        ? "imc-section--padded-top-desktop-" + fields.paddingTopDesktop.value
        : "";
    let paddingBottomDesktop = !!fields.paddingBottomDesktop && fields.paddingBottomDesktop.value!==""
        ? "imc-section--padded-bottom-desktop-" + fields.paddingBottomDesktop.value
        : "";
    let paddingLeftDesktop = !!fields.paddingLeftDesktop && fields.paddingLeftDesktop.value!==""
        ? "imc-section--padded-left-desktop-" + fields.paddingLeftDesktop.value
        : "";
    let paddingRightDesktop = !!fields.paddingRightDesktop && fields.paddingRightDesktop.value!==""
        ? "imc-section--padded-right-desktop-" + fields.paddingRightDesktop.value
        : "";


    // Margin
    let marginTop = !!fields.marginTop && fields.marginTop.value!==""
        ? "imc-section--margin-top-" + fields.marginTop.value
        : "imc-section--margin-top-none";
    let marginBottom = !!fields.marginBottom && fields.marginBottom.value!==""
        ? "imc-section--margin-bottom-" + fields.marginBottom.value
        : "imc-section--margin-bottom-none";
    let marginLeft = !!fields.marginLeft && fields.marginLeft.value!==""
        ? "imc-section--margin-left-" + fields.marginLeft.value
        : "imc-section--margin-left-none";
    let marginRight = !!fields.marginRight && fields.marginRight.value!==""
        ? "imc-section--margin-right-" + fields.marginRight.value
        : "imc-section--margin-right-none";

    // Margin Desktop
    let marginTopDesktop = !!fields.marginTopDesktop && fields.marginTopDesktop.value!==""
        ? "imc-section--margin-top-desktop-" + fields.marginTopDesktop.value
        : "";
    let marginBottomDesktop = !!fields.marginBottomDesktop && fields.marginBottomDesktop.value!==""
        ? "imc-section--margin-bottom-desktop-" + fields.marginBottomDesktop.value
        : "";
    let marginLeftDesktop = !!fields.marginLeftDesktop && fields.marginLeftDesktop.value!==""
        ? "imc-section--margin-left-desktop-" + fields.marginLeftDesktop.value
        : "";
    let marginRightDesktop = !!fields.marginRightDesktop && fields.marginRightDesktop.value!==""
        ? "imc-section--margin-right-desktop-" + fields.marginRightDesktop.value
        : "";
    let extraClass = fields.extraClass? fields.extraClass.fields.className.value : "";

    let innerStyles: Record<string, string> = {};
    if (fields?.styles) {
        Object.keys(fields.styles ?? {}).forEach(function(key) {
            let c = `${fields.styles?.[key]}`;
            if (key.includes("--")) {
                innerStyles[key] = c;
            }
            if (key.includes("background")) {
                innerStyles[key] = c;
            }
        });
    }

    return( 
    <div className={`section-wrapper imc-section--${backgroundColor} ${extraClass} imc-section--relative`} style={(fields.styles) ? fields.styles : {}} ref={sectionRef}>
        {!backgroundVideo && backgroundImage?.src && backgroundImage.src.indexOf("default_image.svg")<0 && <Image className="imc-image--responsive align-image-content imc-section--background-media" field={backgroundImage} />}
        {backgroundVideo && <video className="imc-section--background-media" playsInline autoPlay muted loop src={backgroundVideo} poster={(backgroundImage?.src) ? backgroundImage.src : ''}></video>}
        <section className={`imc-section imc-section--relative imc-content--center imc-section--${backgroundColor} ${extraClass} ${paddingTop} ${paddingBottom} ${paddingLeft} ${paddingRight} ${paddingTopDesktop} ${paddingBottomDesktop} ${paddingLeftDesktop} ${paddingRightDesktop}`}  style={(innerStyles) ? innerStyles : {}}>
            <div className={`${marginTop} ${marginBottom} ${marginLeft} ${marginRight} ${marginTopDesktop} ${marginBottomDesktop} ${marginLeftDesktop} ${marginRightDesktop}`}>
                <div className='imc-section--content-with-image'>
                    <div className={`${editorClasses} imc-section--align-${horizontalContentPosition} ${verticalContentPosition} imc-section--${contentBackgroundColor} imc-content--center-mobile`}>
                    {
                        horizontalContentPosition == 'center-hero' &&
                        <div className={`imc-hero-module--box  imc-hero-module--box--position imc-hero-module--box--padding imc-section--padded imc-section imc-section--full-width-mobile imc-section--${contentBackgroundColor}`}>
                            <Placeholder name="imc-jss-content-section" rendering={rendering} />
                        </div>
                    }
                    {
                        horizontalContentPosition !== 'center-hero' && 
                        <Placeholder name="imc-jss-content-section" rendering={rendering} />
                    }
                    </div>
                </div>
            </div>
        </section>
    </div>
    );
}
export default ContentSectionComponent;
